import { ProductCatalogMap, SelectedItemMap, SerializableDrawingShape } from '@common/models';
import { ColorModel } from '@common/models/color.model';
import { CustomerInfo } from '@common/models/customer-info.model';
import { PricedProduct } from '@common/models/priced-product.model';
import { ProductDetails } from '@common/models/product-details.model';
import { SaveEstimateItem } from '@common/models/save-estimate-dto';

export interface ProductNote {
    productDescription: string;
    note: string;
}

export interface Estimate {
    customerInfo?: Partial<CustomerInfo>;
    estimateNumber?: string;
    zipCode?: string;
    productList?: Partial<ProductDetails>[];
    drawingShapes?: SerializableDrawingShape[];
    storeId?: number;
    color?: ColorModel;
    applySameEdge: boolean;
    qteGrpID: number | null;
    lineItems: SaveEstimateItem[];
    cutOuts: SelectedItemMap;
    tearOuts: SelectedItemMap;
    chipMinimizers: SelectedItemMap;
    faucets: SelectedItemMap;
    optionalProducts: SelectedItemMap;
    plumbingItems: SelectedItemMap;
    productNotes: ProductNote[];
    materialId: string | null;
    materialDesc: string | null;
    productCatalog: ProductCatalogMap;
    pricedProducts: PricedProduct[];
    ticketNumber?: string;
}

/**
 * replicates the constructor from Estimate, creating a new _mutatable_ Estimate with blank values
 * @param customerInfo optional customer info to initialize with
 * @returns a new Estimate object
 */
export const newEstimate = (customerInfo?: Partial<CustomerInfo>): Estimate => ({
    customerInfo: { ...customerInfo }, // clone to
    zipCode: '',
    estimateNumber: '',
    productList: [],
    applySameEdge: true,
    qteGrpID: null,
    lineItems: [],
    cutOuts: new Map(),
    tearOuts: new Map(),
    chipMinimizers: new Map(),
    faucets: new Map(),
    materialId: null,
    materialDesc: null,
    optionalProducts: new Map(),
    plumbingItems: new Map(),
    productNotes: [],
    productCatalog: new Map(),
    pricedProducts: [],
    drawingShapes: [],
});

/**
 * This becomes an immutable new estimate in estimateSlice().
 * We could just use newEstimate when initilizing the data store
 */
export const DEFAULT_ESTIMATE: Estimate = newEstimate();
